/**
 * Mapeo de alta básica (signup y basic) para el programa de referidos.
 * En el request se usa `referralCode`. `CodigoReferidor` en respuesta
 * es el código propio del cliente, no el que usó al registrarse.
 */

import { normalizeReferralCode } from 'utils/referralCode';

/**
 * Construye el payload de POST /users/signup/basic.
 * Incluye `referralCode` solo cuando hay un valor no vacío.
 * @param {object} data Datos del formulario de preregistro
 * @param {object} otp Códigos OTP { email, phone }
 * @returns {object}
 */
export function buildBasicSignupPayload(data = {}, otp = {}) {
  const payload = {
    ...data,
    otp_email: otp.email,
    otp_phone: otp.phone,
  };

  delete payload.referalCode;

  const referralCode = normalizeReferralCode(data.referralCode);
  if (referralCode) {
    payload.referralCode = referralCode;
  } else {
    delete payload.referralCode;
  }

  return payload;
}

/**
 * Normaliza un ítem de `referidos` conservando los campos del API.
 * @param {object} item
 * @returns {object}
 */
export function mapReferralItem(item) {
  if (!item || typeof item !== 'object') {
    return item;
  }

  return {
    ...item,
    registrationDate: item.FechaRegistro,
    referredPoints: item.PuntosReferido,
    referrerPoints: item.PuntosReferidor,
    expirationDate: item.FechaExpirado,
    status: item.Estatus,
    expiredFlag: item.FlagExpirado,
    referredClientName: item.NombreClienteReferido,
    referredClientId: item.IdClienteReferido,
    clientName: item.NombreCliente,
    clientId: item.IdCliente,
  };
}

/**
 * Mapea la respuesta de signup básico sin romper campos existentes
 * (`token`, etc.). `CodigoReferidor` y `referidos` son opcionales.
 * @param {*} response
 * @returns {*}
 */
export function mapBasicSignupResponse(response) {
  if (!response || typeof response !== 'object') {
    return response;
  }

  const mapped = { ...response };

  if (Object.prototype.hasOwnProperty.call(response, 'CodigoReferidor')) {
    mapped.ownReferralCode = response.CodigoReferidor;
  }

  if (Array.isArray(response.referidos)) {
    mapped.referrals = response.referidos.map(mapReferralItem);
  }

  return mapped;
}
